import styled from 'styled-components';
import wixService from '../../../services/wixService';

function roundNum(num) {
  return Math.round(num);
}

function getSearchBG(color) {
  try {
    if (typeof color !== 'undefined') {
      return wixService.getTinycolor(color).setAlpha(0.7).toRgbString();
    }
  } catch (e) {
    console.log('getSearchBG e:', color);
    return color;
  }
}

export const editorXPadding =
  window.Wix &&
  window.Wix.Styles &&
  window.Wix.Styles.getStyleParams((sp) => {
    return sp && sp.booleans.responsive ? ' clear-padding ' : '';
  });

export const SearchBar = styled.div`
  button {
    background: transparent;
    border: none;
  }
`;

export const CategoriesBlockList = styled.div`
  height: 120px;
  background: #ff00e6;
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;

    li {
      float: left;
    }
  }
`;

export const ContainerBlockStyle = styled.div`
  margin: 0;
  padding: 0;
  height: 100% !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0);
  background-color: ${(props) =>
    wixService.getColorByreference(props.design.widget.color.value)};
  background-color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.widget.color.name,
    )};

  &.stripes-colors .category,
  &.collapse-colors .category,
  &.basic-colors .displayCategoriesTop .category1 {
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.categoryOtherText.color.value,
      )};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.categoryOtherText.color.name,
      )};
    ${(props) =>
      wixService.getStyleFontByReference(
        props.design.categoryOtherText.font.value,
      )};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.categoryOtherText.font.name,
      )};
  }
  #accordion .accordion-item {
    border-bottom: ${(props) => parseInt(props.settings.dividerCollapse, 10)}px
      solid transparent;
    border-bottom-color: ${(props) =>
      wixService.getColorByreference(props.design.dividerCollapse.color.value)};
    border-bottom-color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.dividerCollapse.color.name,
      )};
    &:hover {
      background: transparent !important;
    }

    div[data-hook='children'],
    div[data-hook='header'] {
      background: transparent !important;
    }

    &.last {
      border-bottom-width: 0;
    }
  }

  /***************************************Start Spaces ***************************************************/
  > .flexbox-container {
    /*padding-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 30)}px !important;
    padding-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;*/
  }

  .clear-padding {
    padding: 0px !important;
  }

  @media screen and (min-width: 320px) {
    padding-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 30)}px !important;
  }

  .categories-block {
    margin-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;
  }

  .collapse-colors .content .faq-header,
  .content .faq-header {
    margin-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;
  }

  .content .question-basic-view .social-icons {
    margin-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 40)}px !important;
  }

  .margin-bottom30 {
    margin-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 30)}px !important;
  }
  .stripes-view .question-container {
    margin-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 10)}px !important;
  }

  .stripes-view .question-answer {
    padding-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 30)}px !important;
    padding-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;
  }

  .collapse-view .question-heading {
    padding-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 15)}px !important;
    padding-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 15)}px !important;
  }
  .collapse-view .question-heading.first {
    padding-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 15)}px !important;
  }

  .content .social-icons {
    margin-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;
  }
  /* .panel-body {
    padding: 0 0 ${(props) =>
    roundNum(props.settings.spacesPixcel * 15)}px 0 !important;
  }*/
  .basic-view .question-answer-text {
    margin-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 20)}px !important;
  }
  .stripes-view .question-title-box {
    min-height: ${(props) =>
      roundNum(props.settings.spacesPixcel * 100)}px !important;
  }
  .stripes-view .question-title-box .question-title {
    padding-top: ${(props) =>
      roundNum(props.settings.spacesPixcel * 36)}px !important;
    padding-bottom: ${(props) =>
      roundNum(props.settings.spacesPixcel * 36)}px !important;
  }
  /***************************************End Spaces ***************************************************/
`;

export const SocialBarIcons = styled.div``;

export const SearchBlockStyle = styled.div.attrs(() => ({}))`
  @media screen and (max-width: 455px) {
    &.layout-basic,
    &.layout-collapse {
      .search-and-title {
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color: ${(props) =>
          wixService.getColorByreference(
            props.design.questionText.color.value,
          )} !important;
        border-bottom-color: ${(props) =>
          wixService.getColorValueByComponentName(
            props.styleParams,
            props.design.questionText.color.name,
          )} !important;
      }
    }
    &.layout-stripes {
      .search-and-title {
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color: ${(props) =>
          wixService.getColorByreference(
            props.design.questionStripesText.color.value,
          )} !important;
        border-bottom-color: ${(props) =>
          wixService.getColorValueByComponentName(
            props.styleParams,
            props.design.questionStripesText.color.name,
          )} !important;
      }
    }
  }

  .search-no-results,
  .search-label,
  .search-input,
  input select textarea {
    color: ${(props) =>
      wixService.getColorByreference(props.design.questionText.color.value)};
    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionText.color.name,
      )};
  }
  input::placeholder {
    color: ${(props) =>
      getSearchBG(
        wixService.getColorByreference(props.design.questionText.color.value),
      )};
    color: ${(props) =>
      getSearchBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        ),
      )};
  }
  .search-no-results,
  .search-label,
  .search-input,
  input select textarea,
  input::placeholder {
    ${(props) =>
      wixService.getStyleFontByReference(props.design.questionText.font.value)};
    font-size: 14px !important;
    line-height: 14px !important;
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.questionText.font.name,
      )};
    font-size: 14px !important;
    line-height: 14px !important;
    height: 100%;
  }
  &.layout-basic,
  &.layout-collapse {
    .search-box {
      &.active {
        border-color: ${(props) =>
          wixService.getColorByreference(
            props.design.questionText.color.value,
          )};
        border-color: ${(props) =>
          wixService.getColorValueByComponentName(
            props.styleParams,
            props.design.questionText.color.name,
          )};
      }
    }
  }
  &.layout-stripes {
    .search-no-results,
    .search-label,
    .search-input,
    input select textarea,
    input::placeholder,
    .search-input {
      color: ${(props) =>
        wixService.getColorByreference(
          props.design.questionStripesText.color.value,
        )};
      color: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.color.name,
        )};
      ${(props) =>
        wixService.getStyleFontByReference(
          props.design.questionStripesText.font.value,
        )};
      font-size: 14px !important;
      line-height: 14px !important;
      font: ${(props) =>
        wixService.getFontValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.font.name,
        )};
      font-size: 14px !important;
      line-height: 14px !important;
    }

    .search-box {
      &.active {
        border-color: ${(props) =>
          wixService.getColorByreference(
            props.design.questionStripesText.color.value,
          )};
        border-color: ${(props) =>
          wixService.getColorValueByComponentName(
            props.styleParams,
            props.design.questionStripesText.color.name,
          )};
      }
    }
    .search-icon svg path,
    .search-close-icon svg path {
      fill: ${(props) =>
        wixService.getColorByreference(
          props.design.questionStripesText.color.value,
        )} !important;
      fill: ${(props) =>
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.color.name,
        )} !important;
    }
  }
  .search-no-results {
    line-height: 1.5em !important;
  }

  .search-icon svg path,
  .search-close-icon svg path {
    fill: ${(props) =>
      wixService.getColorByreference(
        props.design.questionText.color.value,
      )} !important;
    fill: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionText.color.name,
      )} !important;
  }
`;
